const alunosTurma = [

    //TURMA 1
    {
        turma: "Turma 1",
        info: [
            {
                name: "Bruno R. Rodrigues",
                img_profile: 'assets/img/turma1/bruno.png',
                linkGit: '#'
            },
            {
                name: "Eduardo A. Araújo",
                img_profile: 'assets/img/turma1/eduardo.png',
                linkGit: '#'
            },
            {
                name: "Gabriel B. Cerquinho",
                img_profile: 'assets/img/turma1/gabriel.png',
                linkGit: '#'
            },
            {
                name: "Gleides Silva",
                img_profile: 'assets/img/turma1/gleides.png',
                linkGit: '#'
            },
            {
                name: "Gutemberg B. Ferreira",
                img_profile: 'assets/img/turma1/gutemberg.jpeg',
                linkGit: 'https://www.linkedin.com/in/gutembergbritoferreira/'
            },
            {
                name: "Jeison P. Oliveira",
                img_profile: 'assets/img/turma1/jeison.png',
                linkGit: '#'
            },
            {
                name: "Jonathas B. Cavalcante",
                img_profile: 'assets/img/turma1/jonathas.png',
                linkGit: 'https://www.linkedin.com/in/jonathascavalcante'
            },
            {
                name: "José Alberto Filho",
                img_profile: 'assets/img/turma1/jose.png',
                linkGit: 'https://www.linkedin.com/in/jose-alberto'
            },
            {
                name: "José Rodrigues",
                img_profile: 'assets/img/turma1/mateus.png',
                linkGit: 'https://www.linkedin.com/in/jose-mateus-cordova-rodrigues/'
            },
            {
                name: "Josias B. F. Cavalcante",
                img_profile: 'assets/img/turma1/josias.png',
                linkGit: 'https://www.linkedin.com/in/josiascavalcante/ '
            },
            {
                name: "Josué Lustosa Filho",
                img_profile: 'assets/img/turma1/josue.png',
                linkGit: 'https://www.linkedin.com/in/josue-lustosa/'
            },
            {
                name: "Laura Lima Guedes",
                img_profile: 'assets/img/turma1/laura.png',
                linkGit: '#'
            },
            {
                name: "Nathália R. M. Santos",
                img_profile: 'assets/img/turma1/nathalia.png',
                linkGit: 'https://www.linkedin.com/in/nathalia-santos-ns27/'
            },
            {
                name: "Paula Mendonça",
                img_profile: 'assets/img/turma1/paula.png',
                linkGit: 'https://www.linkedin.com/in/paula-quadros'
            },
            {
                name: "Shermam Lima",
                img_profile: 'assets/img/turma1/shermam.png',
                linkGit: '#'
            },
            {
                name: "Solano Lima Oliveira",
                img_profile: 'assets/img/turma1/solano.png',
                linkGit: 'https://www.linkedin.com/in/solano-lima-oliveira-146b23188/'
            },
            {
                name: "Taynara Costa",
                img_profile: 'assets/img/turma1/taynara.png',
                linkGit: 'https://www.linkedin.com/in/taynara-costa-944798198/'
            },
        ],


    },

    //TURMA 2
    {
        turma: "Turma 2",
        info: [
            {
                name: "Adriano  Gomes",
                img_profile: 'assets/img/turma2/adriano.jpeg',
                linkGit: 'https://www.linkedin.com/in/adriano-gomes-9b1779186/'
            },
            {
                name: "Antônio José Neto",
                img_profile: 'https://ca.slack-edge.com/T052KR1029Y-U05MBSATXMM-872a35a66d02-512',
                linkGit: 'https://www.linkedin.com/in/antonio-fernandes-19287325/'
            },

            {
                name: "Aris Canto",
                img_profile: 'https://ca.slack-edge.com/T052KR1029Y-U05MKP8S30E-26a8d4f035bb-512',
                linkGit: '#'
            },
            {
                name: "Caio Fernandes",
                img_profile: 'https://ca.slack-edge.com/T052KR1029Y-U05NG3ZSDPS-4c5769619cee-512',
                linkGit: 'https://www.linkedin.com/in/caio-fernandes-965196209/'
            },
            {
                name: "Caroline Braz",
                img_profile: 'assets/img/turma2/carol.jpg',
                linkGit: 'https://www.linkedin.com/in/caroline-braz-43961b146/'
            },
            {
                name: "Crislan Rodrigues Cruz",
                img_profile: 'assets/img/turma2/crislan.jpg',
                linkGit: 'https://www.linkedin.com/in/crislancruz'
            },
            {
                name: "Daniel Antunes Ribeiro",
                img_profile: 'https://ca.slack-edge.com/T052KR1029Y-U05MPF7SL6R-824484f7c933-512',
                linkGit: 'https://www.linkedin.com/in/daniel-antunes-ribeiro'
            },
            {
                name: "Eduardo Silva",
                img_profile: 'assets/img/turma2/eduardo.jpg',
                linkGit: '#'
            },
            {
                name: "Eduardo Noji",
                img_profile: 'https://ca.slack-edge.com/T052KR1029Y-U05MS9WJS67-62a81a5b510a-512',
                linkGit: 'https://www.linkedin.com/in/eduardonoji/'
            },
            {
                name: "Francisco Gabriel",
                img_profile: 'https://ca.slack-edge.com/T052KR1029Y-U05MSCQ5BH8-e0218ae3bca9-512',
                linkGit: 'https://www.linkedin.com/in/francisco-gabriel-software/'
            },
            {
                name: "Gabriel Sobrinho",
                img_profile: 'https://ca.slack-edge.com/T052KR1029Y-U05N51YGTMX-75f78d6bb02d-512',
                linkGit: '#'
            },
            {
                name: "Gabriel Amoêdo",
                img_profile: 'https://ca.slack-edge.com/T052KR1029Y-U05346W0E2D-c7b106c98540-512',
                linkGit: 'https://www.linkedin.com/in/gabriel-amo%C3%AAdo-a1b078a7'
            },
            {
                name: "Ícaro Santos",
                img_profile: 'https://avatars.githubusercontent.com/u/46682140?v=4',
                linkGit: 'https://www.linkedin.com/in/icarosun'
            },
            {
                name: "Luiz Gustavo Arruda",
                img_profile: 'assets/img/turma2/luiz.jpg',
                linkGit: 'https://www.linkedin.com/in/luiz-gustavo-arruda-15703194'
            },
            {
                name: "Noah Diunkz",
                img_profile: 'https://avatars.githubusercontent.com/u/18603573?v=4',
                linkGit: 'https://br.linkedin.com/in/diunkz'
            },
            {
                name: "Salomão Cruz",
                img_profile: 'assets/img/turma2/salomao.jpg',
                linkGit: 'https://www.linkedin.com/in/salomao-cruz/'
            },
            {
                name: "Sidney Araújo",
                img_profile: 'https://ca.slack-edge.com/T052KR1029Y-U05MPFVHSE9-ff36e601d52e-512',
                linkGit: 'https://www.linkedin.com/in/sidney-de-araujo-fonseca-20414493'
            },
            {
                name: "Vitor Xavier",
                img_profile: 'assets/img/turma2/vitor.jpg',
                linkGit: '#'
            },
            {
                name: "Vitória Beatriz",
                img_profile: 'https://avatars.githubusercontent.com/u/91225063?v=4',
                linkGit: '#'
            },

        ]
    },

    //TURMA 3
    // {
    //     turma: "Turma 3",
    //     info: [
    //         // {
    //         //     name: "Aluno 1",
    //         //     img_profile: 'https://bootdey.com/img/Content/avatar/avatar2.png',
    //         //     linkGit: 'https://github.com/3'
    //         // },
    //         // {
    //         //     name: "Aluno 2",
    //         //     img_profile: 'https://bootdey.com/img/Content/avatar/avatar4.png',
    //         //     linkGit: 'https://github.com/4'
    //         // },

    //         // {
    //         //     name: "Aluno 3",
    //         //     img_profile: 'https://bootdey.com/img/Content/avatar/avatar4.png',
    //         //     linkGit: 'https://github.com/5'
    //         // },
    //         // {
    //         //     name: "Aluno 3",
    //         //     img_profile: 'https://bootdey.com/img/Content/avatar/avatar5.png',
    //         //     linkGit: 'https://github.com/6'
    //         // },
    //         // {
    //         //     name: "Aluno 3",
    //         //     img_profile: 'https://bootdey.com/img/Content/avatar/avatar6.png',
    //         //     linkGit: 'https://github.com/7'
    //         // },
    //         // {
    //         //     name: "Aluno 3",
    //         //     img_profile: 'https://bootdey.com/img/Content/avatar/avatar7.png',
    //         //     linkGit: 'https://github.com/8'
    //         // },
    //         // {
    //         //     name: "Aluno 3",
    //         //     img_profile: 'https://bootdey.com/img/Content/avatar/avatar8.png',
    //         //     linkGit: 'https://github.com/9'
    //         // },
    //         // {
    //         //     name: "Aluno 3",
    //         //     img_profile: 'https://bootdey.com/img/Content/avatar/avatar8.png',
    //         //     linkGit: 'https://github.com/10'
    //         // },
    //         // {
    //         //     name: "Aluno 3",
    //         //     img_profile: 'assets/img/logo_letra_branca.png',
    //         //     linkGit: 'https://github.com/11'
    //         // },
    //         // {
    //         //     name: "Aluno 3",
    //         //     img_profile: 'assets/img/logo_letra_branca.png',
    //         //     linkGit: 'https://github.com/11'
    //         // },
    //         // {
    //         //     name: "Aluno 3",
    //         //     img_profile: 'assets/img/logo_letra_branca.png',
    //         //     linkGit: 'https://github.com/11'
    //         // },
    //         // {
    //         //     name: "Aluno 3",
    //         //     img_profile: 'assets/img/logo_letra_branca.png',
    //         //     linkGit: 'https://github.com/11'
    //         // },

    //     ]
    // }
]

export default alunosTurma;